module.exports = __webpack_public_path__ + "static/media/home-3.16425aed.jpg";